const Spacer = () => null;

export default Spacer;
